import * as React from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import NotFoundBackgroundImage from "assets/error-page-bg.svg";
import PageContentLayout from "components/layout/PageContentLayout";
import DocumentTitle from "components/common/DocumentTitle";
import ErrorJumbotron from "components/errors/ErrorJumbotron";
const generateStyles = () => css`
  body {
    background: url(${({ backgroundImage }) => backgroundImage}) no-repeat center center fixed;
    background-size: cover;
  }
`;
const ErrorMessage = styled.div(
  ({ theme }) => css`
    margin-left: auto;
    margin-right: auto;
    text-align: left;

    dt {
      font-size: ${theme.fonts.size.body};
      font-weight: normal;
      overflow: auto;
    }

    p {
      font-size: inherit;
    }
  `
);
const ErrorPageStyles = createGlobalStyle`
    ${generateStyles()}
`;
const ErrorPage = ({
  children = void 0,
  title,
  description,
  backgroundImage = NotFoundBackgroundImage,
  displayPageLayout = true
}) => {
  const PageLayoutComponent = displayPageLayout ? PageContentLayout : React.Fragment;
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(PageLayoutComponent, null, /* @__PURE__ */ React.createElement(ErrorPageStyles, { backgroundImage }), /* @__PURE__ */ React.createElement(ErrorJumbotron, { title }, description, children && /* @__PURE__ */ React.createElement(ErrorMessage, null, children))));
};
export default ErrorPage;
